import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
  Button,
  Stack,
  Container,
  Paper,
  Link
} from '@mui/material';
import { styled } from '@mui/material/styles';
import PaymentIllustration from '../assets/images/paymentsimages/Payment.png';
import PaymentBg from '../assets/images/paymentBg.png';

// Styled components for custom styling
const StyledCard = styled(Card)(({ theme }) => ({
  // maxWidth: 800,
  margin: '0 auto',
  borderRadius: 16,
  // boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  // backgroundColor: '#ffffff',
  // border: '1px solid #E0E0E0',
   boxShadow: 'none',
   width:'100%'
  
}));

const IllustrationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  // width: 200,
  // height: 200,
  // borderRadius: '50%',
  // backgroundColor: '#E8F5E9',
  // margin: '0 auto 24px',
  // padding: 20,
}));

const PaymentSection = styled(Paper)(({ theme }) => ({
  padding: '20px',
  border: '1px solid #E0E0E0',
  borderRadius: '8px',
  // backgroundColor: '#F8F9FA',
  backgroundColor:'transparent',
  height: '100%',
  borderBottom:'none',
  borderTop:'none',
  borderLeft:'none',
  borderRight:'none',
  '& .section-title': {
    fontWeight: 'bold',
    fontSize: '1.1rem',
    marginBottom: 16,
    color: ' #4e5056',
    textAlign: 'center',
  },
  '& .payment-detail': {
    marginBottom: 8,
    fontSize: '0.95rem',
    color: ' #4e5056',
    lineHeight: 1.4,
  },
}));

const PlanButton = styled(Button)(({ theme }) => ({
  background: 'linear-gradient(to bottom, #4B77B1, #005498)',
  textAlign: 'center',
  // padding: '12px 70px',
  border: '5px solid #D7D7D8',
  width: '368px',
  height: '60px',
  borderRadius: '50px',
  fontSize: '20px',
  fontWeight: 'bold',
  color: 'white',
  cursor: 'pointer',
  transition: 'background 0.3s ease',
  textTransform: 'capitalize',
  margin: '8px 0',
  '&:hover': {
    background: 'linear-gradient(to bottom, #3A5F8F, #004080)',
  },
}));

const ContactSection = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginTop: 32,
  '& .contact-title': {
    fontWeight: 'bold',
    fontSize: '1.2rem',
    marginBottom: 10,
    color: '#0b8270',
  },
  '& .contact-detail': {
    marginBottom: 8,
    fontSize: '1rem',
    color: '#000',
  },
  '& .contact-link': {
    color: '#2196F3',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));

const Footnote = styled(Typography)(({ theme }) => ({
  fontSize: '0.85rem',
  color: '#666',
  textAlign: 'left',
  marginTop: 24,
  fontStyle: 'italic',
}));

const PaymentsPage = () => {
  const handlePlanClick = (url) => {
    window.open(url, '_blank');
  };

  return (
    
    <Container sx={{ py: 4 }} className='paymentContainer'>
      <StyledCard>
        <CardContent sx={{ p: 4, paddingTop:'0px' , paddingLeft:'0px' , paddingRight:'0px' , display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
          {/* Top Illustration */}
           <div 
             className='bgImage'
             style={{
               backgroundImage: `url(${PaymentBg})`,
               backgroundSize: 'cover',
               backgroundPosition: 'center',
               backgroundRepeat: 'no-repeat',
               minHeight: '100vh',
               width: '100%',
               backgroundPositionY:'100%'
             }}
           >
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <IllustrationContainer>
              <img 
                src={PaymentIllustration} 
                alt="Payment Illustration"
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'contain', 
                  maxWidth:'360px',
                  marginTop:'-25px'
                }}
              />
            </IllustrationContainer>
            
            {/* Main Headings */}
            {/* <Typography 
              variant="h3" 
              sx={{ 
                fontWeight: 'bold', 
                fontSize: { xs: '2rem', md: '2.5rem' },
                color: '#000',
                mb: 1,
                fontFamily: 'var(--heading-font)'
              }}
            >
              Payments
            </Typography>
            <Typography 
              variant="h5" 
              sx={{ 
                fontSize: { xs: '1.2rem', md: '1.5rem' },
                color: '#000',
                fontFamily: 'var(--default-font)'
              }}
            >
              to Jupiter Events LLC
            </Typography> */}
          </Box>

          {/* Payment Details Section */}
          <Box sx={{ mb: 3 , display:'flex', justifyContent:'center', alignItems:'center' }}>
            <Grid container spacing={0} sx={{ position: 'relative' }} className="mobileGridpayment">
              {/* USD Payments */}
              <Grid item xs={12} md={6}>
                <PaymentSection elevation={0} sx={{ 
                  borderRight: { xs: 'none', sm: '1px solid #E0E0E0' },
                  borderBottomRightRadius: { xs: '8px', md: '0' },
                  borderTopRightRadius: { xs: '8px', md: '0' }
                }}>
                  <Typography className="section-title usdPayment">
                    USD Payments
                  </Typography>
                  <Typography className="payment-detail usdPayment">
                    Customer Name: Jupiter Events LLC
                  </Typography>
                  <Typography className="payment-detail usdPayment">
                    Bank Name: First Abu Dhabi Bank PJSC
                  </Typography>
                  <Typography className="payment-detail usdPayment" >
                    Account Number: 1001326744366002
                  </Typography>
                  <Typography className="payment-detail usdPayment">
                    IBAN: AE580351001326744366002
                  </Typography>
                  <Typography className="payment-detail usdPayment">
                    Currency: USD
                  </Typography>
                </PaymentSection>
              </Grid>

              {/* AED Payments */}
              <Grid item xs={12} md={6}>
                <PaymentSection elevation={0} sx={{ 
                  borderLeft: { xs: 'none', sm: '1px solid #E0E0E0' },
                  borderBottomLeftRadius: { xs: '8px', md: '0' },
                  borderTopLeftRadius: { xs: '8px', md: '0' }
                }}>
                  <Typography className="section-title aedPayment">
                    AED Payments
                  </Typography>
                  <Typography className="payment-detail aedPayment">
                    Customer Name: Jupiter Events LLC
                  </Typography>
                  <Typography className="payment-detail aedPayment">
                    Bank Name: First Abu Dhabi Bank PJSC
                  </Typography>
                  <Typography className="payment-detail aedPayment">
                    Account Number: 1001326744366001
                  </Typography>
                  <Typography className="payment-detail aedPayment">
                    IBAN: AE850351001326744366001
                  </Typography>
                  <Typography className="payment-detail aedPayment">
                    Currency: AED
                  </Typography>
                </PaymentSection>
              </Grid>
            </Grid>
          </Box>

          {/* Horizontal Divider */}
          <Divider sx={{ my: 3, borderColor: '#E0E0E0' }} className='dividerpayment'/>

          {/* Payment Confirmation Section */}
          <Box sx={{ textAlign: 'center', mb: 4 }} className="confirmBox">
            <Typography 
              className='confirmVip'
              sx={{ 
                fontSize: '1rem', 
                color: ' #4e5056', 
                mb: 3,
                fontFamily: 'var(--default-font)'
              }}
            >
              To confirm your I Am Peacekeeper Billionaire Patron or VIP Partner commitment, kindly use our secure online payment pages (via credit or debit card):
            </Typography>

            {/* Plan Options */}
            <Stack spacing={2} alignItems="center" className='stripeButtonstack'>
              <PlanButton className='ctaStripebutton'
                onClick={() => handlePlanClick('https://buy.stripe.com/bJe9AS7gPf7U1Rdd1Lc7u0d')}
              >
                💎 VIP Partner – USD 12,000
              </PlanButton>
              <PlanButton className='ctaStripebutton patronButton'
                onClick={() => handlePlanClick('https://buy.stripe.com/14AbJ01Wve3Q1Rdf9Tc7u0v')}
              >
                🚀 Billionaire Patron – USD 21,000
              </PlanButton>
            </Stack>

            <Typography 
              sx={{ 
                fontSize: '0.9rem', 
                color: ' #4e5056', 
                mt: 3,
                fontFamily: 'var(--default-font)'
              }}
              className='amountText'
            >
              Amounts are preset and will be converted into your local currency at checkout. A receipt <br/> and acknowledgement will follow from the I Am Peacekeeper Movement.
            </Typography>
          </Box>

          </div>


          {/* Contact Section */}
           <ContactSection>
             <Typography 
               className="contact-title"
               sx={{
                 fontWeight: '400 !important',
                 fontSize: '40px !important',
                 textAlign: 'center',
                 color: '#0b8270'
               }}
             >
               Contact
             </Typography>
            <Typography className="contact-detail">
              Mr. Gaurav Shinde
            </Typography>
            <Link
              href="https://wa.me/917506007533"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >+91-75060-07533, </Link>
            <Typography 
              className="contact-detail"
              sx={{
                display: { xs: 'block', sm: 'block' },
                textAlign: 'center'
              }}
            >
              <Box 
                component="span"
                sx={{
                  display: { xs: 'block', sm: 'inline' },
                  mb: { xs: 1, sm: 0 }
                }}
              >
                Email: <a href="mailto:gaurav@i-am-peacekeeper.com" className="contact-link">gaurav@i-am-peacekeeper.com</a>
              </Box>
              <Box 
                component="span"
                sx={{
                  display: { xs: 'none', sm: 'inline' },
                  mx: 1
                }}
              >
                |
              </Box>
              <Box 
                component="span"
                sx={{
                  display: { xs: 'block', sm: 'inline' }
                }}
              >
                Website: <a href="https://www.i-am-peacekeeper.com" className="contact-link" target="_blank" rel="noopener noreferrer">www.i-am-peacekeeper.com</a>
              </Box>
            </Typography>
          </ContactSection>

          {/* Footnote */}
          <Footnote className='footnote'>
            Note: Jupiter Events LLC is the umbrella organisation under which all event-related initiatives are conducted, under the Chairmanship of Dr. Huzaifa Khorakiwala
          </Footnote>
        </CardContent>
      </StyledCard>
    </Container>
  );
};

export default PaymentsPage;
